import React from 'react';
export function HeartIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.483 3.985C3.655 2.579 5.343 2 7.064 2c1.743 0 3.1.59 4.091 1.522.33.31.613.653.853 1.014a5.89 5.89 0 01.876-1.02C13.888 2.587 15.258 2 17 2c1.72 0 3.41.58 4.58 1.985 1.166 1.397 1.682 3.448 1.415 6.115-.278 2.778-1.662 5.22-3.567 7.322-1.902 2.099-4.367 3.908-6.914 5.436l-.514.308-.514-.308C6.462 19.844 1.62 15.619 1.069 10.1c-.267-2.667.25-4.718 1.414-6.115zm1.537 1.28c-.71.853-1.194 2.302-.96 4.635.432 4.325 4.202 7.994 8.94 10.929 2.258-1.397 4.345-2.984 5.947-4.75 1.72-1.9 2.836-3.957 3.058-6.179.233-2.333-.25-3.782-.96-4.635C19.34 4.421 18.278 4 17 4c-1.258 0-2.138.412-2.76.985-.637.589-1.056 1.4-1.27 2.258h-1.94c-.217-.868-.624-1.68-1.246-2.265C9.181 4.41 8.321 4 7.064 4c-1.28 0-2.34.42-3.044 1.265z"
  }));
}